import { recoilSelector } from 'common/util/recoil-selector';
import { ComponentsTheme, THEMED_COMPONENT } from '../themes';
import { createStylesGetter } from '../utils';

type AnnotationsTheme = ComponentsTheme[THEMED_COMPONENT.ANNOTATIONS];
export type AnnotationStyles = {
  borderColor: string;
  backgroundColor: string;
  name: string;
};
type AnnotationsStyles = Array<AnnotationStyles>;

const ANNOTATIONS_NAMES = [
  { name: 'Dark Gray' },
  { name: 'Light Gray' },
  { name: 'Forest Green' },
  { name: 'Emerald Green' },
  { name: 'Teal' },
  { name: 'Sky Blue' },
  { name: 'Royal Blue' },
  { name: 'Navy' },
  { name: 'Purple' },
  { name: 'Plum' },
  { name: 'Pink' },
  { name: 'Red' },
  { name: 'Coral' },
  { name: 'Orange' },
];

const prepareAnnotationsStyles = (annotationsTheme: AnnotationsTheme): AnnotationsStyles =>
  Object.values(annotationsTheme).map((annotationTheme, index) => ({
    ...annotationTheme,
    ...ANNOTATIONS_NAMES[index],
  }));

/**
 * This selector returns styles prepared for Annotations alongside texts describing them.
 * The texts could once transfer to the theme object once we understand that they are theme-dependent.
 */
export const annotationStylesState = recoilSelector({
  key: THEMED_COMPONENT.ANNOTATIONS,
  get: createStylesGetter<THEMED_COMPONENT.ANNOTATIONS, AnnotationsStyles>(
    prepareAnnotationsStyles,
    THEMED_COMPONENT.ANNOTATIONS,
  ),
});
